var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "container" }, [
    _c(
      "header",
      { staticClass: "broker-details-header" },
      [
        _c("h2", { staticClass: "broker-details-header-title" }, [
          _vm._v(" " + _vm._s(_vm.$t(`brokerDetailsPageTitle`)) + " "),
        ]),
        _vm.backButton
          ? _c(
              "b-button",
              {
                staticClass:
                  "is-button-secondary is-small is-rounded is-pulled-right ml-2",
                attrs: { id: "return-btn" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
            )
          : _vm._e(),
        _vm.showSimulationButton
          ? _c(
              "b-button",
              {
                staticClass:
                  "is-button-primary is-small is-rounded is-pulled-right mb-2",
                attrs: {
                  id: "simulation-button",
                  tag: "a",
                  "icon-left": "fa-solid fa-user-plus",
                  href: _vm.buildSimulatorFrontUrl(),
                  "data-cy": "simulation-button",
                  target: "_blank",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("simulator")) + " ")]
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "card-item prospect-info mb-3" },
      [
        _vm.isLoadingBrokerData || _vm.isLoadingBrokerProspects
          ? _c("Spinner")
          : [
              _vm.broker.name
                ? _c("BrokerData", {
                    attrs: {
                      broker: _vm.broker,
                      "user-is-broker": _vm.userIsBroker,
                      "is-updating-status": _vm.isUpdatingStatus,
                    },
                    on: { updateBrokerStatus: _vm.updateBrokerStatus },
                  })
                : _vm._e(),
              _vm.brokerProspects.length > 0
                ? [
                    _c("BrokerLeads", {
                      attrs: { "prospects-from-brokers": _vm.brokerProspects },
                    }),
                    _vm.brokerProspects.length > 0
                      ? _c("CredituPagination", {
                          attrs: {
                            "documents-per-page":
                              _vm.pagination.documentsPerPage,
                            total: _vm.pagination.numberOfDocuments,
                            "page-number": _vm.pagination.pageNumber,
                            size: "is-small",
                            "items-name": "Leads",
                            "range-before": 1,
                            "range-after": 1,
                            "documents-per-page-options": [5, 10, 20, 50],
                          },
                          on: {
                            "update:documentsPerPage": [
                              function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "documentsPerPage",
                                  $event
                                )
                              },
                              function ($event) {
                                return _vm.catchUpdatePagination(
                                  "setPaginationDocumentsPerPage",
                                  $event
                                )
                              },
                            ],
                            "update:documents-per-page": function ($event) {
                              return _vm.$set(
                                _vm.pagination,
                                "documentsPerPage",
                                $event
                              )
                            },
                            "update:pageNumber": [
                              function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "pageNumber",
                                  $event
                                )
                              },
                              function ($event) {
                                return _vm.catchUpdatePagination(
                                  "setPaginationPageNumber",
                                  $event
                                )
                              },
                            ],
                            "update:page-number": function ($event) {
                              return _vm.$set(
                                _vm.pagination,
                                "pageNumber",
                                $event
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                : _c("Message", {
                    attrs: {
                      message: _vm.message.message,
                      icon: _vm.message.icon,
                      "as-card": false,
                    },
                  }),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }